<template>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="miniVariant"
      :clipped="false"
      fixed
      app
      permanent
    >
      <v-list>
        <v-list-item @click="resizeMenu">
          <v-list-item-action>
           
              <v-icon>mdi-{{ `chevron-${miniVariant ? 'right' : 'left'}` }}</v-icon>
           
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title />
          </v-list-item-content>
        </v-list-item>

        <v-list-item  v-for="(item, i) in items" :key="i" @click="page(item.to)" :disabled="!item.enabled">
          <v-list-item-action>
            
            <v-icon :disabled="!item.enabled" :color="active == item.to ? 'red' : ''">{{ item.icon }}</v-icon>
           
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      active: null,
      miniVariant: true,
      drawer: true,
      items: [
        {
          icon: "mdi-apps",
          title: this.$t("menu.overwiev"),
          to: "AppIndex",
          enabled: true
        },
        {
          icon: "mdi-qrcode",
          title: this.$t("menu.qrgen"),
          to: "",
          enabled: false
        },
        {
          icon: "mdi-cube-outline",
          title: this.$t("menu.products"),
          to: "Products",
          enabled: true
        },
        {
          icon: "mdi-factory",
          title: this.$t("menu.factory"),
          to: "Factory",
          enabled: true
        },
        {
          icon: "mdi-developer-board",
          title: this.$t("menu.dev"),
          to: "",
          enabled: false
        },
        {
          icon: "mdi-car-back",
          title: this.$t("menu.cars"),
          to: "",
          enabled: false
        },
        {
          icon: "mdi-human-queue",
          title: this.$t("menu.human"),
          to: "",
          enabled: false
        },
        {
          icon: "mdi-face-agent",
          title: this.$t("menu.customer"),
          to: "Customers",
          enabled: true
        },
        {
          icon: "mdi-cart-outline",
          title: this.$t("menu.supplier"),
          to: "Suppliers",
          enabled: true
        },
        {
          icon: "mdi-store",
          title: this.$t("menu.stock"),
          to: "Stock",
          enabled: true
        },
        {
          icon: "mdi-star-outline",
          title: this.$t("menu.reviews"),
          to: "",
          enabled: false
        }
      ],
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  mounted(){
    if(!this.$route.params.section){
      this.active = 'AppIndex'
    }else{
      this.active = this.$route.params.section
    }
  },
  methods: {
    resizeMenu() {
      this.miniVariant = this.miniVariant ? false : true;
    },
    page(val){
      this.active = val
      this.$emit('page',val)
    }
  },
};
</script>

<style scoped>

</style>